import {ref, computed} from 'vue';
import {getProducts} from '@api/products';

export const dataRepository = () => {
    const loading = ref(false);
    const products = ref([]);
    const discount_config = ref([]);
    const reviews = ref([]);
    const config = ref({});
    const pickupTowns = ref({});
    const dataLoading = computed(() => loading.value);

    const loadData = () => {
        loading.value = true;
        getProducts().then(response => {
            products.value = response.products;
            discount_config.value = response.d_config;
            config.value = response.config;
            pickupTowns.value = response.pickupTowns;
            reviews.value = response.reviews;
            loading.value = false;
        });
    };

    return {
        loadData,
        dataLoading,
        products,
        discount_config,
        config,
        reviews,
        pickupTowns
    };
};
